const { sanitiseBatchNo } = require('../batch/tools')
const { fsShipmentDateParser } = require('../shipment/tools/safe-date-parser')

function createBatchHelpers ({ mainApi, logger }) {
  async function upsertBatchDetails ({ skuCode, batchNo, manufacturer, expiry }) {
    if (!skuCode || !batchNo) return
    const sanitizedBatchNo = sanitiseBatchNo(batchNo)
    const productId = `product:${skuCode}`
    const manufacturerId = manufacturer && manufacturer !== '' ? manufacturer : 'unknown'

    try {
      await mainApi.batch.new({
        productId,
        manufacturer: manufacturerId,
        batchNo: sanitizedBatchNo,
        expiry: expiry || new Date('2099-12-31').toJSON()
      }, { validateManufacturer: false, allowUpdates: true })
    } catch (err) {
      const batchId = `product:${skuCode}:manufacturer:${manufacturerId}:batchNo:${sanitizedBatchNo}`
      logger.warn({ err, batchId }, 'shipsy: failed to create new batch')
    }
  }

  async function fromGrn (items = []) {
    for (const item of items) {
      if (!item || !item.batch_number || !item.expiry_date) continue
      await upsertBatchDetails({
        skuCode: item.sku_code,
        batchNo: item.batch_number,
        expiry: new Date(fsShipmentDateParser(item.expiry_date)).toJSON()
      })
    }
  }

  async function fromRtv (items = []) {
    for (const item of items) {
      if (!item || !item.batch_no || !item.expiry_date) continue
      await upsertBatchDetails({
        skuCode: item.sku_code,
        batchNo: item.batch_no,
        expiry: new Date(item.expiry_date).toJSON()
      })
    }
  }

  async function fromInvoice (items = []) {
    for (const item of items) {
      const batches = Array.isArray(item.batch_details) ? item.batch_details : []
      for (const batch of batches) {
        if (!batch || !batch.batch_no) continue
        await upsertBatchDetails({
          skuCode: item.sku_code,
          batchNo: batch.batch_no,
          expiry: new Date(batch.expiry_date).toJSON()
        })
      }
    }
  }

  async function fromSalesReturn (items = []) {
    for (const item of items) {
      if (!item || !item.batch_number) continue
      await upsertBatchDetails({
        skuCode: item.sku_code,
        batchNo: item.batch_number,
        expiry: new Date(item.expiry_date).toJSON()
      })
    }
  }

  return {
    fromGrn,
    fromRtv,
    fromInvoice,
    fromSalesReturn,
    upsertBatchDetails
  }
}

module.exports = createBatchHelpers
